import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

export default function initializeMovie() {
    window.onload = function() {
        document.querySelectorAll(".block-movie").forEach(function (block) {
            new Collapse(block);
        });
    }
}

class Collapse {
    constructor(block) {
        this.block = block;
        this.init();
    }

    init() {
        gsap.registerPlugin(ScrollTrigger);
        ScrollTrigger.defaults({ markers: false });

        let tl = gsap.timeline({
            scrollTrigger: {
                trigger: ".block-movie__door",
                start: "top 80%",
                end: "bottom 100%",
                pinSpacing: false,
                pin: false,
                scrub: true
            }
        })

        gsap.set(".block-movie__door__item--left", { x: -window.innerWidth / 2 });
        gsap.set(".block-movie__door__item--right", { x: window.innerWidth / 2 });

        const ease = "power3.inOut";
        const speed = 0.5;
        const delay = 0.2;

        tl.to(
            ".block-movie__door__item--left",
            { x: 0, duration: 0.4 },
            0
        ).to(
            ".block-movie__door__item--right",
            { x: 0, duration: 0.4 },
            0
        );

        ScrollTrigger.create({
            start: self => tl.scrollTrigger.end,
            end: "max",
            pinSpacing: false,
            pin: false,
        });

    }
}